// extracted by mini-css-extract-plugin
module.exports = {"a":"UniqaAd_a__3TNfZ","disabled":"UniqaAd_disabled__L8sMR"};